firebird.factory('videoSimulcastToggleService', [
    '$timeout',
    'logService',
    'configService',
    'helperService',
    'videoGlobalService',
    'attendeeListService',
    'contentService',
    'attendeeService',
    'socketService',
    function (
        $timeout,
        logService,
        configService,
        helperService,
        videoGlobalService,
        attendeeListService,
        contentService,
        attendeeService,
        socketService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoSimulcastToggleService');

        const idlePhase = 'idle';
        const switchingPhase = 'switching';
        const donePhase = 'done';

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // current state of simulcast publisher if video is unmuted.
            self.simulcastFlag = false;

            self.initSimulcastToggle = initSimulcastToggle;
            self.initSimulcastFlag = initSimulcastFlag;
            self.toggleSimulcastIfNeeded = toggleSimulcastIfNeeded;
            self.toggleSimulcast = toggleSimulcast;
            self.getIsScreenShareActive = getIsScreenShareActive;
            self.resetSimulcastStartedInRemoteFeeds = resetSimulcastStartedInRemoteFeeds;
            self.markSimulcastTogglePhaseAsIdle = markSimulcastTogglePhaseAsIdle;
            self.markSimulcastTogglePhaseAsSwitching = markSimulcastTogglePhaseAsSwitching;
            self.markSimulcastTogglePhaseAsDone = markSimulcastTogglePhaseAsDone;
            self.isSimulcastTogglePhaseIdle = isSimulcastTogglePhaseIdle;
            self.isSimulcastTogglePhaseSwitching = isSimulcastTogglePhaseSwitching;
            self.isSimulcastTogglePhaseDone = isSimulcastTogglePhaseDone;
            self.stopSimulcastToggleTimer = stopSimulcastToggleTimer;
            self.startSimulcastToggleTimer = startSimulcastToggleTimer;
            self.setTempPosterToVideoElement = setTempPosterToVideoElement;
            self.cleanupLocalVideoElementStream = cleanupLocalVideoElementStream;
            self.stopRemovePosterTimer = stopRemovePosterTimer;
            self.stopAllRemovePosterTimers = stopAllRemovePosterTimers;

            self.simulcastToggleTimer = null;
            self.posterTimersMap = new Map();

            self.simulcastToggleConfig = {
                enabled: false,
                onBitrateLow: false,
                pauseOnRestart: true, // pause videos on restart or stay with black video box
                disableCutoff: 12, // if video count increases > 12 then disable simulcast
                enableCutoff: 10, // if video count decreases <= 10 then re-enable simulcast
                constraints: {
                    width: 320,
                    height: 180,
                    frameRate: 15
                },
                enablePauseVideo: false,
                simulcastToggleTimeout: 3000,
                clearPosterTimeout: 10000
            };

            // these state attributes together determine whether the simulcastFlag is set or not.
            self.simulcastToggleState = {
                attendeeCount: 0,
                videoCount: 0,
                contentPlaying: false,
                bitrateLow: false,
                restricted: false, // true if simulcast disabled due to large video count with content playing.
                phase: idlePhase // possible values: 'idle', 'switching', 'done'
            };

            $scope.$on('attendee-list-count-updated', onAttendeeListCountUpdated);
            $scope.$on('video-feed-count', onVideoFeedCountChange);
            $scope.$on('internal-content-stopped', onContentStopped);
            $scope.$on('internal-content-playing', onContentPlaying);
            $scope.$on('internal-content-status', onContentStatus);
            $scope.$on('pause-attendee-video', onPauseAttendeeVideo);
        }

        function initSimulcastToggle() {
            self.setConfigObjectFromValue(
                'enableSimulcastToggle',
                configService.getValue('enableSimulcastToggle'),
                self.simulcastToggleConfig
            );

            // should not be higher than 'low video' resolution
            const config = self.simulcastToggleConfig;
            config.constraints.width = Math.min(config.constraints.width, 640);
            config.constraints.height = Math.min(config.constraints.height, 360);

            if (self.simulcastAt === 0 || self.simulcastAt === self.simulcastAtMax) {
                config.enabled = false;
                config.onBitrateLow = false;
                logger.log('initSimulcastToggle', `disabled due to pre-configured simulcastAt=${self.simulcastAt}`);
            } else {
                config.disableCutoff = Math.max(config.disableCutoff, self.simulcastAt);
                config.enableCutoff = Math.min(config.enableCutoff, config.disableCutoff);
            }

            if (config.enabled) {
                logger.log('initSimulcastToggle', `enabled with config ${JSON.stringify(config)}`);
            }
        }

        function initSimulcastFlag() {
            const config = self.simulcastToggleConfig;

            const data = {
                attendeeCount: attendeeListService.getAttendeeCountForSimulcastCondition().length
            };

            if (config.enabled) {
                data.contentPlaying = self.getIsScreenShareActive();
                data.videoCount = self.videoFeedCount;

                if (!attendeeService.getIsVideoMuted()) {
                    data.videoCount += 1;
                }
            }

            self.toggleSimulcastIfNeeded(data, true);
        }

        function onContentPlaying(e, data) {
            if (!helperService.getIsMeetingEnding()) {
                self.toggleSimulcastIfNeeded({ contentPlaying: data.ownerID > 0 });
            }
        }

        function onContentStopped(e, data) {
            if (!helperService.getIsMeetingEnding()) {
                self.toggleSimulcastIfNeeded({ contentPlaying: false });
            }
        }

        function onContentStatus(e, data) {
            if (!helperService.getIsMeetingEnding()) {
                self.toggleSimulcastIfNeeded({ contentPlaying: data.state === 'running' });
            }
        }

        function onAttendeeListCountUpdated(e, data) {
            self.toggleSimulcastIfNeeded({ attendeeCount: data.new });
        }

        function onVideoFeedCountChange(e, count) {
            if (!helperService.getIsMeetingEnding()) {
                self.toggleSimulcastIfNeeded({ videoCount: count });
            }
        }

        function toggleSimulcastIfNeeded(data, initOnly) {
            const config = self.simulcastToggleConfig;
            const state = self.simulcastToggleState;

            if (data) {
                // TODO: only these attributes in data should be allowed: contentPlaying, attendeeCount, videoCount, bitrateLow.
                Object.assign(state, data);
            }

            const oldValue = self.simulcastFlag;

            if (config.enabled && !(self.simulcastAt === 0 || self.simulcastAt === self.simulcastAtMax)) {
                // There could be a situation when video count is between the cutoffs. For newly joined attendee we don't know
                // simulcast state: it could be true, because we not reached the disableCutoff or false, because
                // previously we reached the disableCutoff, then turned off some webcams, but not reached enableCutoff.
                // In this case joined attendee will have different simulcast state.
                const cutoff = oldValue || initOnly ? config.disableCutoff : config.enableCutoff - 1;
                const largeVideoCount = state.videoCount > cutoff;
                const enoughAttendees = state.attendeeCount >= self.simulcastAt;
                const largeVideoWithContent = largeVideoCount && state.contentPlaying;
                const bitrateLow = self.simulcastToggleConfig.onBitrateLow && state.bitrateLow;
                const newValue = !bitrateLow && enoughAttendees && !largeVideoWithContent;
                state.restricted = enoughAttendees && (largeVideoWithContent || bitrateLow);

                if (oldValue !== newValue) {
                    self.simulcastFlag = newValue;

                    logger.log(
                        'setSimulcastStateFlag',
                        `simulcastFlag ${oldValue} to ${newValue}, state is ${JSON.stringify(state)}`
                    );
                }
            } else {
                // old condition
                self.simulcastFlag = state.attendeeCount >= self.simulcastAt;
            }

            if (!initOnly && oldValue !== self.simulcastFlag) {
                if (self.simulcastToggleConfig.enablePauseVideo) {
                    socketService.send({ message: 'pause-attendee-video', data: { reason: 'simulcast toggle' } });
                    self.startSimulcastToggleTimer();
                } else {
                    self.toggleSimulcast();
                }
            }
        }

        function toggleSimulcast() {
            self.markSimulcastTogglePhaseAsSwitching();
            self.republishAfterSimulcastChanged();

            if (!self.simulcastFlag) {
                // also reset the simulcastStarted flags of various remote feeds.
                // TODO: this will not work if different simulcastAt values are used for different clients,
                // or if simulcast publish is always enabled, e.g., on mobile clients. or different
                // clients in the meeting have different enableSimulcastToggle config.
                self.resetSimulcastStartedInRemoteFeeds();
            }
        }

        function stopSimulcastToggleTimer() {
            if (self.simulcastToggleTimer) {
                $timeout.cancel(self.simulcastToggleTimer);
                self.simulcastToggleTimer = null;
            }
        }

        function startSimulcastToggleTimer() {
            self.stopSimulcastToggleTimer();
            self.simulcastToggleTimer = $timeout(function () {
                self.simulcastToggleTimer = null;
                self.toggleSimulcast();
            }, self.simulcastToggleConfig.simulcastToggleTimeout);
        }

        function stopRemovePosterTimer(fid) {
            if (self.posterTimersMap.has(fid)) {
                $timeout.cancel(self.posterTimersMap.get(fid));
                self.posterTimersMap.delete(fid);
            }
        }

        function stopAllRemovePosterTimers() {
            self.posterTimersMap.forEach((_, key) => {
                self.stopRemovePosterTimer(key);
            });
        }

        function getIsScreenShareActive() {
            // TODO: need to include multishare too
            return contentService.getIsScreenShareActive();
        }

        function resetSimulcastStartedInRemoteFeeds() {
            for (let s in self.feeds) {
                let feed = self.feeds[s];
                if (typeof feed === 'object' && feed.simulcastStarted) {
                    // may be undefined, true or false
                    feed.simulcastStarted = false;
                }
            }
        }

        function markSimulcastTogglePhaseAsIdle() {
            setSimulcastTogglePhase(idlePhase);
        }

        function markSimulcastTogglePhaseAsSwitching() {
            setSimulcastTogglePhase(switchingPhase);
        }

        function markSimulcastTogglePhaseAsDone() {
            setSimulcastTogglePhase(donePhase);
        }

        function setSimulcastTogglePhase(phase) {
            self.simulcastToggleState.phase = phase;
        }

        function isSimulcastTogglePhaseIdle() {
            return self.simulcastToggleState.phase === idlePhase;
        }

        function isSimulcastTogglePhaseSwitching() {
            return self.simulcastToggleState.phase === switchingPhase;
        }

        function isSimulcastTogglePhaseDone() {
            return self.simulcastToggleState.phase === donePhase;
        }

        function onPauseAttendeeVideo(e, data) {
            self.pauseVideo(data.attendantId);
            self.setTempPosterToVideoElement(data.attendantId);

            // we should set video element's stream to null to prevent black video flickering
            // it occurs when we call cleanupWebrtc and stopping video track, but do nothing with stream
            if (data.attendantId === self.attendantId) {
                self.cleanupLocalVideoElementStream();
            }
        }

        function setTempPosterToVideoElement(fid) {
            const video = $(`[user='${fid}']>video`)[0];
            if (video) {
                logger.log('setTempPosterToVideoElement', `fid=${fid}`);

                let canvas = document.createElement('canvas');
                canvas.width = 320;
                canvas.height = 180;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                const image = canvas.toDataURL('image/jpeg');
                video.poster = image;

                self.stopRemovePosterTimer(fid);
                const removePosterTimer = $timeout(() => {
                    logger.log('setTempPosterToVideoElement->remove poster', `fid=${fid}`);
                    self.stopRemovePosterTimer(fid);
                    video.removeAttribute('poster');
                }, self.simulcastToggleConfig.clearPosterTimeout);
                self.posterTimersMap.set(fid, removePosterTimer);
            }
        }

        function cleanupLocalVideoElementStream() {
            const video = $window.$('#videoroom-videos > div.local > video')[0];
            if (video) {
                logger.log('cleanupLocalVideoElementStream', 'cleanup srcObject');
                video.srcObject = null;
            }
        }
    }
]);
